import { render, staticRenderFns } from "./RecordsCoupon.vue?vue&type=template&id=39b97602&"
import script from "./RecordsCoupon.vue?vue&type=script&lang=js&"
export * from "./RecordsCoupon.vue?vue&type=script&lang=js&"
import style0 from "./RecordsCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports